/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow

import { ADDRESS_PRIMARY_TYPES } from './addressPredictionTypes.js';

export const MIN_QUERY_LENGTH = 3;

type Args = {|
  input: string,
  regionCode: ?string,
  sessionToken?: ?Object,
|};

// Imperative rather than conditional spreads: Flow rejects two unions spread into one literal.
const autocompleteSuggestionsRequest = ({ input, regionCode, sessionToken }: Args): Object => {
  const request: Object = {
    input,
    includedPrimaryTypes: ADDRESS_PRIMARY_TYPES,
  };
  if (regionCode) {
    request.includedRegionCodes = [regionCode];
  }
  if (sessionToken) {
    request.sessionToken = sessionToken;
  }
  return request;
};

export default autocompleteSuggestionsRequest;
